import { useObserver } from 'mobx-react-lite';

import { tracker } from 'src/utils/analytics';
import useUser from 'src/hooks/use-user';
import { useModals, ModalNames } from 'src/components/modals';
import { useLoginNudgeContext } from './login-nudge-context';

type UseLoginNudgeReturn = {
  shouldShowNudge: boolean;
  dismissNudge: () => void;
  handleNudgeClick: () => void;
};

export const useLoginNudge = (): UseLoginNudgeReturn => {
  const User = useUser();
  const isLoggedIn = useObserver(() => User.isLoggedIn);
  const isLoading = useObserver(() => User.loading);

  const { openModal } = useModals();
  const { isDismissed, dismissNudge } = useLoginNudgeContext();

  const shouldShowNudge = !isLoading && !isLoggedIn && !isDismissed;

  const handleNudgeClick = (): void => {
    tracker.loginNudge({ action: 'clicked' });
    dismissNudge();
    void openModal(ModalNames.login);
  };

  const conditionallyDismissNudge = (): void => {
    if (shouldShowNudge) {
      dismissNudge();
    }
  };

  return {
    shouldShowNudge,
    dismissNudge: conditionallyDismissNudge,
    handleNudgeClick,
  };
};
